// extracted by mini-css-extract-plugin
export default {"container":"AuthScreen_container__Ef0En","headerText":"AuthScreen_headerText__2Si4w"};